import { Trash2, Pencil, ChevronDown, Info, Eye } from "lucide-react";
import { format } from "date-fns";
import { toast } from "react-hot-toast";
import { useState } from "react";
import Cookies from "js-cookie";
import {
  updateEventStatus,
  updateEventApproval,
  deleteEvent,
} from "../../../services/eventsServices";

export const EventsListTable = ({
  events = [],
  refetch,
  currentIndex = 0,
  entriesPerPage = 10,
  isHide = false,
  permissionsData,
}) => {
  const [openStatusDropdownId, setOpenStatusDropdownId] = useState(null);
  const [openApprovalDropdownId, setOpenApprovalDropdownId] = useState(null);

  console.log(permissionsData, "permissionsData");

  const role = Cookies.get("role");

  let canEdit = false;
  let canDelete = false;
  let canUpdateStatus = false;
  let canUpdateApproval = false;

  if (role === "admin") {
    canEdit = true;
    canDelete = true;
    canUpdateStatus = true;
    canUpdateApproval = true;
  } else if (role === "maintainer" && permissionsData?.permissions) {
    const modulePermissions = permissionsData.permissions.find(
      (p) => p.module === "Events"
    );

    console.log("modulePermissions found:", modulePermissions);

    if (modulePermissions) {
      canEdit = modulePermissions.edit === true;
      canDelete = modulePermissions.delete === true;
      canUpdateStatus = modulePermissions.edit === true;
      canUpdateApproval = modulePermissions.edit === true;
    }
  }
  const showActions = canEdit || canDelete;

  const handleUpdateStatus = async (id, newStatus) => {
    if (!canUpdateStatus) {
      toast.error("You don't have permission to update status");
      return;
    }

    try {
      await updateEventStatus(id, newStatus);
      toast.success("Status updated");
      setOpenStatusDropdownId(null);
      refetch?.();
    } catch {
      toast.error("Failed to update status");
    }
  };

  const handleUpdateApproval = async (id, newApprovalStatus) => {
    if (!canUpdateApproval) {
      toast.error("You don't have permission to update approval");
      return;
    }

    try {
      await updateEventApproval(id, newApprovalStatus);
      toast.success("Approval updated");
      setOpenApprovalDropdownId(null);
      refetch?.();
    } catch {
      toast.error("Failed to update approval");
    }
  };

  const handleDelete = async (id) => {
    if (!canDelete) {
      toast.error("You don't have permission to delete events");
      return;
    }

    try {
      await deleteEvent(id);
      toast.success("Event deleted");
      refetch?.();
    } catch {
      toast.error("Failed to delete event");
    }
  };

  const renderStatusDropdown = (eventId, status) => {
    const options = [
      {
        label: "Active",
        value: "active",
      },
      {
        label: "In-active",
        value: "in-active",
      },
    ];

    const current = options.find((o) => o.value === status);

    if (!canUpdateStatus || isHide) {
      return (
        <span
          className={`capitalize font-semibold text-xs px-3 py-[6px] rounded-full ${
            status === "active"
              ? "bg-green text-white"
              : "bg-gray-300 text-gray-800"
          }`}
        >
          {current?.label}
        </span>
      );
    }

    return (
      <div className="flex items-center gap-2">
        <div className="relative inline-block text-left">
          <button
            onClick={() =>
              setOpenStatusDropdownId((prev) =>
                prev === eventId ? null : eventId
              )
            }
            className={`flex items-center justify-center gap-1 text-xs w-[120px] whitespace-nowrap py-[6px] rounded-full capitalize ${
              status === "active"
                ? "bg-green text-white"
                : "bg-gray-300 text-gray-800"
            }`}
          >
            {current?.icon}
            {current?.label}
            <ChevronDown size={14} />
          </button>

          {openStatusDropdownId === eventId && (
            <div
              onMouseLeave={() => setOpenStatusDropdownId(null)}
              className="absolute z-10 mt-1 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
            >
              <div className="py-1">
                {options.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => handleUpdateStatus(eventId, opt.value)}
                    className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 flex items-center gap-2 ${opt.color}`}
                  >
                    {opt.icon}
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="relative group">
          <Info size={14} className="text-gray-500 cursor-pointer" />
          <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-transform duration-200 origin-bottom bg-black text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap z-50">
            Please update status
          </div>
        </div>
      </div>
    );
  };

  const renderApprovalDropdown = (eventId, approvalStatus) => {
    const options = [
      {
        label: "Approved",
        value: "approved",
      },
      {
        label: "Pending",
        value: "pending",
      },
      {
        label: "Rejected",
        value: "rejected",
      },
    ];

    const current = options.find((o) => o.value === approvalStatus);

    // If user can't update approval or isHide is true, show as read-only
    if (!canUpdateApproval || isHide) {
      return (
        <span
          className={`capitalize font-semibold text-xs px-3 py-[6px] rounded-full ${
            approvalStatus === "approved"
              ? "bg-green text-white"
              : approvalStatus === "pending"
              ? "bg-yellow-500 text-white"
              : "bg-red text-white"
          }`}
        >
          {current?.label}
        </span>
      );
    }

    return (
      <div className="flex items-center gap-2">
        <div className="relative inline-block text-left">
          <button
            onClick={() =>
              setOpenApprovalDropdownId((prev) =>
                prev === eventId ? null : eventId
              )
            }
            className={`flex items-center gap-1 text-xs px-3 py-[6px] rounded-full capitalize ${
              approvalStatus === "approved"
                ? "bg-green text-white"
                : approvalStatus === "pending"
                ? "bg-yellow-500 text-white"
                : "bg-red text-white"
            }`}
          >
            {current?.icon}
            {current?.label}
            <ChevronDown size={14} />
          </button>

          {openApprovalDropdownId === eventId && (
            <div
              onMouseLeave={() => setOpenApprovalDropdownId(null)}
              className="absolute z-10 mt-1 w-36 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
            >
              <div className="py-1">
                {options.map((opt) => (
                  <button
                    key={opt.value}
                    onClick={() => handleUpdateApproval(eventId, opt.value)}
                    className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 flex items-center gap-2 ${opt.color}`}
                  >
                    {opt.icon}
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="relative group">
          <Info size={14} className="text-gray-500 cursor-pointer" />
          <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-transform duration-200 origin-bottom bg-black text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap z-50">
            Please update approval
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-x-auto min-h-[500px]">
      <table className="min-w-full table-fixed text-sm border border-gray-300">
        <thead className="bg-[#4F22D8] text-white text-base">
          <tr>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-400">
              No
            </th>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-400 w-[300px]">
              Title
            </th>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-400">
              Date
            </th>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-400">
              Status
            </th>
            <th className="py-3 px-4 text-left font-semibold border-r border-gray-400">
              Approval
            </th>
            {/* Conditionally render Actions header */}
            {showActions && (
              <th className="py-3 px-4 text-left font-semibold">Actions</th>
            )}
          </tr>
        </thead>
        <tbody>
          {events.length === 0 ? (
            <tr>
              <td
                colSpan={showActions ? 6 : 5}
                className="text-center py-4 text-gray-500"
              >
                No events found.
              </td>
            </tr>
          ) : (
            events.map((event, idx) => (
              <tr
                key={event._id}
                className="border-t align-top border-gray-300 text-[15px] hover:bg-gray-50 transition-colors"
              >
                <td className="px-4 py-3 pl-7 text-black border-r border-gray-300">
                  {/* FIXED: Correct serial number calculation */}
                  {currentIndex + idx + 1}
                </td>
                <td className="px-4 py-3 text-black border-r border-gray-300 w-[300px] leading-snug whitespace-normal break-words">
                  {event.title}
                </td>
                <td className="px-2 py-3 text-black border-r whitespace-nowrap border-gray-300">
                  {format(new Date(event.date), "dd MMM yyyy")}
                </td>
                <td className="px-2 py-3 border-r border-gray-300">
                  {renderStatusDropdown(event._id, event.status)}
                </td>
                <td className="px-4 py-3 border-r border-gray-300">
                  {renderApprovalDropdown(event._id, event.approvalStatus)}
                </td>
                {showActions && (
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <button
                        onClick={() => {
                          window.location.href = `/admin/events/view-details?eventId=${
                            event._id
                          }&&title=${encodeURIComponent(event.title)}`;
                        }}
                        className="text-purple-600 font-semibold text-sm flex items-center gap-1 transition-colors"
                      >
                        <Eye size={14} />
                        View
                      </button>

                      {canEdit && (
                        <>
                          <button
                            onClick={() => {
                              window.location.href = `/admin/events/edit-event?eventId=${event._id}`;
                            }}
                            className="text-darkblue font-semibold text-sm flex items-center gap-1 transition-colors"
                          >
                            <Pencil size={14} />
                            Edit
                          </button>
                          {canDelete && (
                            <div className="w-px h-4 bg-gray-300" />
                          )}
                        </>
                      )}

                      {canDelete && (
                        <button
                          onClick={() => handleDelete(event._id)}
                          className="text-[#D40404] font-semibold text-sm flex items-center gap-1 transition-colors"
                        >
                          <Trash2 size={14} />
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
